<template>
  <div class="news">
    <CCard class="filter">
      <div class="filter-header">Bộ lọc dữ liệu</div>
      <CRow class="row-mobile">
        <CCol col="12" sm="6" xl="6">
          <CRow class="py-2">
            <CCol sm="3">
              <div class="form-group">
                <label>Danh mục</label>
                <select class="form-control" v-model="searchData.newCategory">
                  <option value="0">
                    {{ $t("placeholder.label_employee_option_search") }}
                  </option>
                  <option
                    :value="category.id"
                    v-for="(category, index) in categories"
                    :key="index"
                  >
                    {{ category.name }}
                  </option>
                </select>
              </div>
            </CCol>

            <div class="btn-search" @click="searchNew">
              <img class="mr-2" src="../../assets/icons/search.svg" alt="" />
              Tìm kiếm
            </div>
          </CRow>
        </CCol>
      </CRow>
    </CCard>

    <div class="table-list">
      <CCard class="table-list__wrapper">
        <div class="option-table">
          <div class="option-table__header">Danh sách tin tức</div>
          <div class="option-table__create">
            <router-link
              :to="{
                path: `news/create`,
              }"
            >
              <div class="btn-create__news">
                <img
                  class="mr-2"
                  src="../../assets/icons/plus.svg"
                  alt=""
                /><span> Thêm tin tức </span>
              </div>
            </router-link>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th width="5%">#</th>
                <th width="10%">Danh Mục</th>
                <th width="25%">Tiêu Đề</th>
                <th width="20%">Thumbnail</th>
                <th width="12%">Người Tạo</th>
                <th width="12%">Ngày Tạo</th>
                <th scope="col" class="min-w-130">
                  {{ $t("label.action") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-if="news.data && news.data.length > 0">
                <tr v-for="(item, index) in news.data" :key="index">
                  <td>
                    <!-- {{ item }} -->
                    {{ (news.current_page - 1) * news.per_page + index + 1 }}
                  </td>
                  <td>{{ item.category.name }}</td>
                  <td>{{ item.title }}</td>
                  <td>
                    <img
                      :src="item.thumbnailImage"
                      class="img_thumbnail"
                      alt=""
                    />
                  </td>
                  <td>{{ item.creator.name }}</td>
                  <td>{{ formateDate(item.created_at) }}</td>
                  <td class="justify-content-center">
                    <router-link
                      :to="{
                        path: `news/edit/${item.id}`,
                        params: { id: item.id },
                      }"
                    >
                      <CButton
                        color="primary"
                        variant="outline"
                        square
                        size="sm"
                        >{{ $t("fields.new.update") }}</CButton
                      >
                    </router-link>
                    <span class="mr-1"></span>
                    <CButton
                      color="danger"
                      variant="outline"
                      square
                      size="sm"
                      @click="deleteItem(item.id)"
                      >{{ $t("fields.new.delete") }}
                    </CButton>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td colspan="13" class="text-center">
                    {{ $t("table.label_data_not_found") }}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <CPagination
          v-if="news.data && news.data.length > 0"
          :activePage.sync="searchData.paginate.currentPage"
          :pages="searchData.paginate.totalPage"
          @update:activePage="changePage"
          size="sm"
          align="center"
        />
      </CCard>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import "sweetalert2/src/sweetalert2.scss";
import moment from "moment";

export default {
  name: "NewList",
  metaInfo() {
    return {
      title: this.$t("page_title.page_new_list"),
      titleTemplate: "%s | " + this.$t("page_title.head_title"),
    };
  },

  data() {
    return {
      searchData: {
        newCategory: 0,
        itemsPerPage: 10,
        paginate: {
          from: 0,
          to: 0,
          totalPage: 0,
          path: "",
          currentPage: 1,
          totalRecord: 0,
          perPage: 0,
        },
      },
    };
  },

  computed: {
    ...mapGetters({
      news: "news/newList",
      listItemsPerPage: "commons/listItemsPerPage",
      categories: "news/categories",
      pagination: "news/pagination",
      account: "auth/account"
    }),
  },

  created() {
    this.fetchNewList();
  },

  methods: {
    ...mapActions("news", ["deleteNews"]),
    async fetchNewList() {
      this.$root.$loading.start();
      await this.$store.dispatch("news/fetchListNew", {
        currentPage: this.searchData.paginate.currentPage,
      });
      this.searchData.paginate = this.pagination;
      this.$root.$loading.finish();
    },

    async searchNew() {
      this.$root.$loading.start();
      await this.$store.dispatch("news/fetchListNew", {
        currentPage: this.searchData.paginate.currentPage,
        category: this.searchData.newCategory != 0 ? this.searchData.newCategory : null,
      });
      this.searchData.paginate = this.pagination;
      this.$root.$loading.finish();
    },

    changePage(page) {
      this.fetchNewList(this.searchData.itemsPerPage, page);
    },

    routeCreate() {
      this.$router.push({ path: "/news/create" });
    },

    async deleteItem(newId) {
      this.$confirmModal(
        this.$t("popup.label_popup_text"),
        this.$t("popup.label_popup_title"),
        this.$t("popup.label_confirm_button"),
        this.$t("popup.label_cancel_button"),
        "danger"
      ).then((value) => {
        if (value) {
          this.deleteNews(newId)
            .then(() => {
              this.fetchNewList();
              this.$toast(
                this.$t("popup.label_popup_success_text"),
                null,
                2000,
                "b-toaster-top-center",
                "success"
              );
            })
            .catch(() => {
              this.$toast(
                this.$t("popup.label_popup_error_text"),
                null,
                2000,
                "b-toaster-top-center",
                "error"
              );
            });
        }
      });
    },

    formateDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
  },
};
</script>

<style lang="scss" scoped>
.news {
  .filter {
    padding: 20px 24px;
    border: none;

    .filter-header {
      font-weight: 700;
      font-size: 18px;
      line-height: 22px;
      color: #3d4cdc;
      padding-bottom: 20px;
      border-bottom: thin solid #eaeaea;
    }

    .btn-search {
      display: flex;
      margin-top: 29px;
      padding: 7px;
      background: #3d4cdc;
      font-weight: 700;
      height: 35px;
      color: #ffffff;
      max-width: 210px;
      border-radius: 10px;
      text-align: center;
      width: 100%;
      cursor: pointer;
      justify-content: center;
      align-items: center;
    }
  }

  .table-list {
    .table-list__wrapper {
      padding: 10px 24px;

      .option-table {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 10px;

        .option-table__header {
          color: #3d4cdc;
          font-weight: 700;
          font-size: 18px;
        }

        .option-table__create {
          max-width: 210px;
          background: #ececec;
          width: 100%;
          border-radius: 10px;
          padding: 11px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          a {
            text-decoration: none;

            .btn-create__news {
              display: flex;
              align-items: center;
              justify-content: center;
              span {
                font-weight: 700;
                font-size: 14px;
                color: #3d4cdc;
              }
            }
          }
        }
      }

      tbody {
        tr {
          th {
            vertical-align: middle !important;
          }
          td {
            vertical-align: middle !important;
            font-weight: 400;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            max-width: 200px;
            .img_thumbnail {
              height: 100px;
            }
          }
        }
      }
    }
  }
}
</style>
